<template>
    <span
        class="lni-c-alert--error"
        :class="isForGlobalList ? '--global' : '--inline'"
        role="alert"
    >

        <template v-if="isForGlobalList">
            <a
                href="#"
                v-scroll-to="bookmark"
                v-on:click="setFocus()"
                ><span class="lnicon--exclamation" aria-hidden="true"></span>{{ globalText }}</a>
        </template>
        <template v-else>
            <span class="lnicon--exclamation" aria-hidden="true"></span>{{ localText }}
        </template>
    </span>
</template>


<script>
import framework from '../../framework';
/**
 *  The x-error component
 *  @module components/x-error
 */


/**
 * The x-error component represent an error message
 */
export default {
    name: 'x-error',
    mixins: [
        framework.mixins.abstractElement,
    ],
    props: {
        dataGlobal: Boolean,
        dataId: String,
        dataGlobalText: String,
        dataLocalText: String,
        dataCode: String,
    },
    computed: {
        /**
         * The bookmark for the global error to link to the error itself.
         * @returns {string} bookmark string.
         */
        bookmark() {
            let id = '';
            if (this.dataId) {
                id = this.dataId;
            }
            return `#${id}`;
        },
        /**
         * Whether this is for the global or inline error.
         * @returns {boolean} see above.
         */
        isForGlobalList() {
            return this.dataGlobal;
        },
        /**
         * The text for the local error message.
         * @returns {string} message.
         */
        localText() {
            if (this.dataLocalText) {
                return this.dataLocalText;
            }

            if (this.nodeManifest) {
                return this.nodeManifest.errors[0].localText;
            }

            return 'Error Message';
        },

        /**
         * The text for the local error message.
         * @returns {string} message.
         */
        globalText() {
            if (this.dataGlobalText) {
                return this.dataGlobalText;
            }

            if (this.nodeManifest) {
                return this.nodeManifest.errors[0].globalText;
            }

            return 'Error Message';
        },

        /**
         * The code for the error.
         * @returns {string} the error code.
         */
        value() {
            if (this.dataValue) {
                return this.dataValue;
            }

            if (this.nodeManifest) {
                return this.nodeManifest.errors[0].value;
            }

            return null;
        },
    },
    methods: {
        setFocus() {
            document.querySelector(`#${this.dataId}`).focus();
        },
    },
};

</script>

<style lang="scss">
    @import
        "../../styles/settings",
        "alert";
</style>



// WEBPACK FOOTER //
// source/components/x-error/x-error.vue